var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":_vm.diameter,"height":_vm.diameter}},[_c('path',{attrs:{"d":_vm._path,"fill":_vm.color}})])}
var staticRenderFns = []

export { render, staticRenderFns }